import { CellWidthStyled } from 'components/Table/helpers/CellWidth/CellWidthStyled';
import Tooltip from 'components/Tooltip/Tooltip';

/**
 * Benchmark Name Column Cell Formatter
 * @param props
 * @param pageIndex
 * @param pageSize
 * @param maxWidth
 * @returns
 */
export const CellBenchmarkName = (
  props: any,
  pageIndex: number,
  pageSize: number,
  maxWidth: number
) => {
  const {
    cell: { value },
    row: {
      original: { typeId, id },
    },
  } = props;

  return (
    <Tooltip message={value} delay={300}>
      <CellWidthStyled maxWidth={maxWidth}>
        <a
          href={`/benchmarks/${typeId}/${id}?page=${pageIndex}&pagesize=${pageSize}`}
        >
          {value}
        </a>
      </CellWidthStyled>
    </Tooltip>
  );
};
